export const stateStyles = {
  "&.pending": {
    backgroundColor: "rgba(176, 188, 182, 0.15)",
  },
  "&.starting": {
    backgroundColor: "rgba(76, 206, 120, 0.10)",
  },
  "&.created": {
    backgroundColor: "rgba(33, 150, 243, 0.10)",
  },
  "&.error": {
    backgroundColor: "rgba(255, 73, 73, 0.15)",
    color: "#d32f2f",
  },
  "&.stopping": {
    backgroundColor: "rgba(171, 171, 171, 0.2)",
  },
  "&.stopped": {
    backgroundColor: "rgba(212, 212, 212, 0.1)",
  },
  "&.destroyed": {
    backgroundColor: "rgba(250, 185, 78, 0.15)",
  },
  "&.pause": {
    backgroundColor: "rgba(170, 170, 255, 0.15)",
  },
};

export const stateToClassName = (state: string): string => {
  switch (state) {
    case "pending":
    case "queued":
    case "scaling":
      return "pending";
    case "starting":
    case "creating":
      return "starting";
    case "ready":
    case "started":
    case "created":
      return "created";
    case "error":
      return "error";
    case "deleting":
    case "stopping":
      return "stopping";
    case "stopped":
      return "stopped";
    case "destroying":
    case "destroyed":
      return "destroyed";
    case "pausing":
    case "paused":
      return "pause";
    default:
      return "";
  }
};
